import React, { Fragment, useState, useEffect } from 'react';
import $ from 'jquery';

import PageViewersModal from './PageViewersModal';
import ViewerAvatar from '../ViewerAvatar';
import { pluralText } from '../../utilities/wordUtilities';

const CurrentUserAvatar = () => {
    const currentUserId = window.userId;

    return <ViewerAvatar userId={currentUserId} key={`viewer-${currentUserId}`} />;
};

const PageViewsContainer = (props) => {
    const [showViewersModal, setShowViewersModal] = useState(false);
    const [views, setViews] = useState(null);
    const [anonViewCount, setAnonViewsCount] = useState(null);

    let activeRequest = null;

    useEffect(() => {
        getViews();
        return (() => {
            if (activeRequest) {
                activeRequest.abort();
            }
        });
    }, [props.page]);

    const getViews = () => {
        if (!props.page || !props.page.id) return;
        setViews(null);

        if (activeRequest) {
            activeRequest.abort();
        }

        activeRequest = $.get(`/api/teams/${window.teamId}/pages/${props.page.id}/page-views`);

        return activeRequest
            .done(({ unique_views, anonymous_views }) => {
                setViews(unique_views);
                setAnonViewsCount(anonymous_views);
            });
    };

    if (!views) {
        return (<button className="viewers" disabled><span className="silver">- viewers</span></button>);
    }

    let displayViewers = views.length;
    if (!views.find(view => view.user_id === window.userId)) {
        displayViewers += 1;
    }

    const viewersText = pluralText(displayViewers, 'viewer');
    const viewsWithoutCurrentUser = views.filter(view => view.user_id != window.userId);
    const MAX_AVATARS = 5;

    return (
        <Fragment>
            <button className="viewers" onClick={() => setShowViewersModal(true)}>
                <CurrentUserAvatar />
                { viewsWithoutCurrentUser.slice(0, MAX_AVATARS).map(view => <ViewerAvatar userId={view.user_id} key={`viewer-${view.user_id}`} />) }
                <span className="ml1">{viewersText}</span>
            </button>
            { showViewersModal
                && (
                    <PageViewersModal
                        page={props.page}
                        views={views}
                        anonViewCount={anonViewCount}
                        closeModal={() => setShowViewersModal(false)}
                    />
                )}
        </Fragment>
    );
};

export default PageViewsContainer;
